var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/NodeSort/groupSort.ts";
import "core-js/modules/es.array.concat.js";
import { isUserClassifierGroupNode } from "../../classifier-service/Node";
export function groupSort(nodeArr, nodes) {
  var otherNodes = [];
  var groups = [];

  for (var i = 0; i < nodeArr.length; i++) {
    var node = nodeArr[i];

    if (isUserClassifierGroupNode(node)) {
      groups.push(node);
    } else {
      otherNodes.push(node);
    }
  }

  return [].concat(groups, otherNodes);
}